import React from "react";
import CommonImageSlider from "./comandata";
import { prePrimary, stateBoardImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import FAQ from "./commonfaq";
import { prePrimaryFaq } from "./faqdata";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";


const seopages = {
    title: "Best Pre School in Hyderabad | Rankridge Pre-Primary School",
    description:
      " Rankridge Pre-School in Hyderabad provides a safe, joyful, and skill-focused learning space for toddlers. Build creativity, communication, and social skills early. Admissions open.",
    keywords: " best preschool in hyderabad, pre primary school hyderabad, montessori schools hyderabad, nursery school hyderabad, kindergarten school hyderabad, play school hyderabad, early childhood education hyderabad, preschool admissions hyderabad, rankridge preschool, best play school near me, child development programs hyderabad, early learning center hyderabad, best kindergarten hyderabad, safe preschool hyderabad, skill based preschool hyderabad, creative learning for kids hyderabad, preschool with activities hyderabad, preschool admission 2025, preschool for toddlers hyderabad, early education hyderabad",
    canonical_path: "https://rankridgeschools.com/pre-primary-education/",
    og_description: "",
    og_image: "",
  };

const title="About Our Pre-Primary Programme"
 const description="  The early years of childhood are a time of wonder, curiosity, and discovery. At Rankridge Schools, our Pre-Primary programme is designed to give children the perfect start by blending care, creativity, and structured early childhood education. Recognized among the best pre-primary schools in Hyderabad near Kukatpally and Miyapur, we focus on learning through play, imagination, and joyful experiences. Our classrooms are safe, bright, and welcoming, with teachers who nurture each child like their own. Through storytelling, music, movement, art, and hands-on exploration, children develop social skills, confidence, and early literacy and numeracy in a natural way. At Rankridge, we believe pre-primary is not just preparation for school.it is the foundation for a lifelong love of learning, friendships, and growth."


const PrePrimary = () => {
  return (
    <div> 
      <h1 className="text-2xl capitalize font-bold text-center m-3">Rankridge Pre-Primary School in Hyderabad – Best Nursery, LKG & UKG Education
</h1>
      {/* <CommonAboutHeader  images={prePrimary} title={title} des={description}/> */}
          <CommonAboutHeader  images={prePrimary} title={title} des={description}/>


 {/* <CommonImageSlider  images={prePrimary}/> */}
     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
  {/* <h2 className="text-xl text-center capitalize sm:text-xl font-semibold text-[black]  m-2">Where little steps today build the brightest futures tomorrow – Rankridge Pre-Primary.

</h2>
  <section className="m-3 text-center">
  <h2 className="text-2xl font-bold">About Rankridge Pre-Primary School</h2>
  <p className="text-start m-2">
    At Rankridge Pre-Primary School, Hyderabad, we believe that little steps lead
    to big dreams. Our early childhood program for Nursery, LKG, and UKG is designed
    to give children the perfect start in life — blending learning with play,
    building confidence, and nurturing curiosity.
  </p>
  <p className="text-start m-2">
    From the moment children step into our colorful, safe, and welcoming campus,
    they feel at home. With a warm and caring environment, we ensure that every
    child is prepared for both academic success and life skills.
  </p>
</section> */}

<div className="bg-[#20b2aa] text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12 space-y-16">
  <div className="grid grid-cols-1 lg:grid-cols-1 items-center gap-10">
    <div className="space-y-1 text-gray-800 text-justify">
      {/* 1 */}
      <div className="border bg-white border-gray-300 p-6 rounded-xl mt-4 text-left">
        <h2 className="text-xl font-bold text-black">
          1. World-Class, Child-Friendly Infrastructure
        </h2>
        <ul className="list-disc pl-6">
          <li>Spacious, airy, and well-lit classrooms with interactive smart boards.</li>
          <li>Safe, age-appropriate furniture and play equipment.</li>
          <li>Dedicated indoor play zones and outdoor activity spaces.</li>
          <li>Secure campus with 24/7 safety monitoring and hygiene protocols.</li>
        </ul>
      </div>

      {/* 2 */}
      <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 text-left">
        <h2 className="text-xl font-bold text-black">
          2. Expert Teachers Who Care Like Parents
        </h2>
        <ul className="list-disc pl-6">
          <li>
            Our teaching team is specially trained in early childhood development
            and understands how to make learning fun, engaging, and effective.
            They are not just teachers — they are mentors, caregivers, and role
            models for your child’s formative years.
          </li>
        </ul>
      </div>

      {/* 3 */}
      <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 text-left">
        <h2 className="text-xl font-bold text-black">
          3. Play-Based & Activity-Based Learning Excellence
        </h2>
        <ul className="list-disc pl-6">
          <li><span className="font-semibold">Storytelling & Role Play:</span> Improves language, imagination, and confidence.</li>
          <li><span className="font-semibold">Music & Dance:</span> Encourages rhythm, expression, and joy.</li>
          <li><span className="font-semibold">Arts & Crafts:</span> Builds creativity and fine motor skills.</li>
          <li><span className="font-semibold">Sensory Activities:</span> Boost brain development and curiosity.</li>
        </ul>
        <h3 className="text-lg sm:text-xl font-semibold text-black mt-4">
          By blending academics with play, we make sure learning never feels like a burden.
        </h3>
      </div>

      {/* 4 */}
      <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 text-left">
        <h2 className="text-xl font-bold text-black">
          4. Focus on Social & Emotional Development
        </h2>
        <ul className="list-disc pl-6">
          <li>
            At Rankridge, we believe education is more than ABCs and 123s. Our
            program helps children develop teamwork, empathy, leadership skills,
            and self-confidence — traits that last a lifetime.
          </li>
        </ul>
      </div>
    </div>

    {/* 5 */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 lg:mt-0 text-left">
      <h2 className="text-xl font-bold text-black">
        5. Academic Readiness for a Bright Future
      </h2>
      <ul className="list-disc pl-6">
        <li>
          Our LKG and UKG curriculum ensures that children transition smoothly
          into primary school with strong skills in literacy, numeracy,
          communication, and critical thinking.
        </li>
      </ul>
    </div>
  </div>

  {/* Parents Trust */}
  <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 text-left">
    <h2 className="text-xl font-bold text-black">
      Why Parents Across Hyderabad Trust Rankridge?
    </h2>
    <ul className="list-disc pl-6 mt-2">
      <li>Best pre-primary school in Hyderabad for holistic growth.</li>
      <li>Smooth nursery admissions in Hyderabad with a transparent process.</li>
      <li>Proven reputation as a top LKG UKG school in Hyderabad.</li>
      <li>Balanced focus on academics, creativity, and physical development.</li>
      <li>Hygienic, safe, and caring environment for every child.</li>
    </ul>
  </div>

  {/* Foundation */}
  <div className="border bg-white border-gray-300 p-6 rounded-xl mt-10 text-left">
    <h2 className="text-xl font-bold text-black">
      Rankridge – A Foundation That Lasts a Lifetime
    </h2>
    <ul className="list-disc pl-6">
      <li>
        When you choose Rankridge Pre-Primary School, you’re choosing more than
        a school — you’re choosing a partner in your child’s early learning
        journey. Our methods are backed by research, our teachers are fueled by
        passion, and our results speak for themselves.
      </li>
    </ul>
  </div>

  {/* Tagline */}
  <div className="text-left mb-8 bg-white p-4">
    <h2 className="text-xl sm:text-2xl font-semibold text-black mb-2">
      Rankridge Pre-Primary School – Where Little Steps Lead to Big Dreams
    </h2>
    <p>
      Every child’s journey begins with a first step — and at Rankridge
      Pre-Primary School in Hyderabad, we make sure that step is strong,
      confident, and full of joy.
    </p>
    <p className="mt-5">
      Recognized as one of the best pre-primary schools in Hyderabad, Rankridge
      is where learning meets love, and education is blended with play. We offer
      a world-class early childhood program for Nursery, LKG, and UKG, designed
      to nurture curiosity, build confidence, and instill a lifelong passion for
      learning.
    </p>
    <h2 className="text-xl sm:text-2xl font-semibold text-black mt-5 mb-2">
      A School Where Your Child Feels at Home
    </h2>
    <p>
      Parents choose Rankridge pre-primary education because we create a warm,
      secure, and inspiring environment where children look forward to coming
      every day. Our mission is simple — to give each child a joyful start to
      education, ensuring they are ready for both academic success and life’s
      challenges.
    </p>
    <p className="mt-5">
      From the first day, children are greeted with bright smiles, colorful
      classrooms, and a sense of belonging that makes Rankridge a second home.
    </p>
  </div>

  {/* Admissions */}
  <div className="bg-[#f9fafb] border border-gray-300 p-6 rounded-xl mt-10 text-left">
    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-black mb-4">
      Admissions Open – Give Your Child the Rankridge Advantage!
    </h3>
    <p className="text-base md:text-lg mb-2">
      If you are searching for a play school with activity-based learning or want
      to ensure early childhood development in Hyderabad at its best, your search
      ends here.
    </p>
    <p><span className="font-semibold">📍 Location:</span> Hyderabad</p>
    <p><span className="font-semibold">📞 Call Us:</span> +91 99 59 303 873</p>
    <p><span className="font-semibold">🌐 Visit:</span> www.rankridgeschools.com</p>
    <p className="font-semibold mt-2">
      Seats for Nursery, LKG, and UKG are limited — secure your child’s future
      with Rankridge Pre-Primary Education today!
    </p>
  </div>
</div>


     <FAQ data={prePrimaryFaq} />
      <SeoMeta seopages={seopages} />
    </div>
  );
};
export default PrePrimary